/**
 * admin/src/hooks/useSidebar.ts
 * Sidebar collapsed state — persists to localStorage
 */

import { useState, useEffect } from 'react';

export function useSidebar() {
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem('admin-sidebar-collapsed') === 'true';
  });

  useEffect(() => {
    localStorage.setItem('admin-sidebar-collapsed', String(collapsed));
    // Drive CSS via data-attribute on <html> — no JS loop needed
    if (collapsed) {
      document.documentElement.setAttribute('data-sidebar', 'collapsed');
    } else {
      document.documentElement.removeAttribute('data-sidebar');
    }
  }, [collapsed]);

  function toggleSidebar() {
    setCollapsed((c) => !c);
  }

  return { collapsed, toggleSidebar };
}
